import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class InstrumentMappingsLookup extends ModelBase {

    public genericInstrumentMappingId: number = 0;

    public stockbroker: string = "";

    public staticInstrument: string = "";

    public instrumentCode: string = "";

    public description: string = "";

    public instrumentType: string = "";

    public isin: string = "";

    public instrumentSubType: string = "";

    public exchange: string = "";

    public select: boolean = false;
}
